import { createTheme } from '@mui/material'
import type {} from '@mui/lab/themeAugmentation'

export const appTheme = createTheme({
  palette: {
    primary: {
      main: 'rgb(3, 34, 76)',
      contrastText: '#fff',
    },
    secondary: {
      main: '#edf2ff',
      contrastText: 'rgb(3, 34, 76)',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          contained: {
            '&:first-letter': {
              textTransform: 'uppercase',
            },
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          background: '#FFFFFF',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: 'red' },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
  },
})

export const appPurchaseTheme = createTheme({
  palette: {
    primary: {
      main: 'rgb(3, 34, 76)',
      light: 'rgb(219, 196, 67)',
    },
    secondary: {
      main: 'rgb(33, 186, 229)',
    },
    info: {
      main: 'rgb(33, 186, 229)',
    },
    error: {
      main: 'rgb(235, 60, 71)',
    },
  },
  typography: {
    fontFamily: '"Inter"',
    body2: {
      marginBottom: '24px',
      fontSize: '16px',
      lineHeight: '24px',
      color: '#283a5b',
      fontWeight: 400,
      '@media (max-width:900px)': {
        fontSize: '14px',
        marginBottom: '16px',
        lineHeight: '20px',
      },
    },
    h5: {
      fontSize: '24px',
      marginBottom: '24px',
      lineHeight: '32px',
      fontWeight: 500,
      '@media (max-width:900px)': {
        fontSize: '20px',
        marginBottom: '16px',
        lineHeight: '28px',
      },
    },
    h6: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      color: '#8a94a6',
    },
    caption: {
      fontWeight: 500,
      fontSize: '12px',
      lineHeight: '16px',
      color: 'rgb(3, 34, 76)',
      textTransform: 'uppercase',
      marginBottom: '8px',
    },
    subtitle1: {
      fontSize: '20px',
      lineHeight: '28px',
      fontWeight: 500,
      margin: '24px 0 12px',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          '&:first-letter': {
            textTransform: 'uppercase',
          },
        },
        contained: {
          color: '#fff',
          backgroundColor: 'rgb(3, 34, 76)', // senin verdiğin renk
          '&:hover': {
            backgroundColor: 'rgb(2, 28, 64)', // hover efekti (opsiyonel)
          },
        },
        outlined: {
          color: '#fff',
          borderColor: '#fff',
          '&:hover': {
            borderColor: '#fff',
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
          },
        },
        text: {
          color: '#fff',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          background: '#FFFFFF',
          height: '48px',
          '& .MuiInputBase-input': {
            borderRadius: 4,
            position: 'relative',
            border: '1px solid rgb(225, 228, 232)',
            fontSize: 14,
            padding: '13px 16px',
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: 'rgb(235, 60, 71)' },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          padding: '24px',
          borderRadius: '4px',
          border: '1px solid #f1f2f4',
          boxShadow: 'none',
          color: '#050f21',
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          padding: '0',
          borderRadius: '',
          border: '1px solid rgb(3, 34, 76)',
          boxShadow: 'none',
          color: '#050f21',
          height: '34px',
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          padding: '0',
          color: '#b7bbc2',
          margin: 0,
          borderRadius: 0,
          fontSize: '14px',
          fontWeight: 500,
          backgroundColor: '#fff',
          '&:hover': {
            backgroundColor: 'rgb(3, 34, 76)',
            color: '#fff',
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          border: '1px solid #e1e4e8',
          background: '#fafbfb',
          '& th': {
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: 400,
            padding: '8px 12px',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          border: '1px solid #e1e4e8',
          padding: '8px 16px',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover td': {
            color: 'rgb(3, 34, 76)',
          },
          '&:hover svg': {
            color: 'rgb(3, 34, 76)',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          height: '48px',
          fontSize: '14px',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          background: 'transparent',
        },
      },
    },
  },
})
